import { rget, DEV_URL } from "utils/requests";

/**
 * Fetch all clients from the API
 * @returns {Promise} Promise that resolves to the list of clients
 */
export const getAllClients = async () => {
  try {
    const endpoint = `${DEV_URL}/api/client/GetAllClients`;
    const response = await rget(endpoint);

    if (response && response.status === 200) {
      return response.data || [];
    }

    console.error("Failed to fetch clients:", response);
    return [];
  } catch (error) {
    console.error("Error fetching all clients:", error);
    return [];
  }
};
